import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpUtil } from '../../../shared/util/http.util';
import { ApplicationConfig } from '../../../core/config/application.config';

@Injectable({ providedIn: 'root' })
export class DistributorApiService {
  constructor(private readonly httpUtil: HttpUtil) {}

  getList(): Observable<string[]> {
    return this.httpUtil.get(`${ApplicationConfig.apiUrl}/distributors`);
  }
}
